import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Card, CardDescription, CardTitle } from '@wfp-common/components/card/Card';

import { windowStorage, WindowStorageToken } from '../windowStorage';
import { authLogin } from '../apiClient';
import { Profile } from '../icons/Profile';

const LoggedOutPage: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const managerToken = windowStorage.getItem(WindowStorageToken.managerApiToken);

        if (managerToken) {
            navigate('/');
        }
    }, [navigate]);

    const handleLogin = () => {
        const returnUrl = sessionStorage.getItem('returnUrl');
        authLogin(returnUrl || undefined).then((r) => {
            if (r.login_url) {
                window.location.replace(r.login_url);
            }
        });
    };

    return (
        <PageWrapper>
            <Card>
                <Icon>
                    <Profile />
                </Icon>
                <CardTitle>You are not logged in</CardTitle>
                <CardDescription>
                    Please log in to access your account and continue using the application.
                </CardDescription>
                <button className="wfp-btn--primary" onClick={handleLogin} type={'button'}>
                    Log In
                </button>
            </Card>
        </PageWrapper>
    );
};

const PageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Icon = styled.div`
    margin-bottom: 24px;
`;

export default LoggedOutPage;
